module.exports = __webpack_public_path__ + "img/agenda_session_img3.bc8e8ebb.png";